// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-logo-top {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-logo-top .top-logo-img {
  height: 50px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
}
.auth-logo-top .top-logo-img:hover {
  transform: scale(1.05);
}
@media (max-width: 1024px) {
  .auth-logo-top {
    top: 20px;
  }
  .auth-logo-top .top-logo-img {
    height: 40px;
  }
}
@media (max-width: 576px) {
  .auth-logo-top {
    top: 15px;
  }
  .auth-logo-top .top-logo-img {
    height: 35px;
  }
}

.auth-wrapper {
  position: relative;
  display: flex !important;
  align-items: stretch !important;
  justify-content: flex-start !important;
  /* There is ONE scroller on this page and it is the page itself.
     \`overflow-x: hidden\` with \`overflow-y: visible\` is not a valid pair — CSS
     computes the visible axis to \`auto\` — so this quietly made the wrapper its
     own scroll container. The decorative sweep below then swung THAT box's
     scroll height between 687px and 1750px every 6s (measured), which is the
     scrollbar that crept down, reset, and crept again. \`html, body\` already
     carry \`overflow-x: hidden\` (responsive.css §1), so the wrapper needs no
     overflow of its own; it must only never clip the form again. */
  overflow: visible;
  min-width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background:
    radial-gradient(1100px 700px at 85% -10%, var(--primary-soft) 0%, transparent 60%),
    radial-gradient(900px 650px at -10% 110%, var(--primary-soft) 0%, transparent 55%),
    var(--page-bg);
}
/* Both ambient layers are FIXED, not absolute. They are full-viewport
   decoration, and \`shimmer\` below translates its layer a whole viewport in each
   direction (plus a 45deg rotation, which grows its box by ~1.41x). As absolute
   children that travel was added to the ancestor's scrollable height on every
   frame; a fixed box is anchored to the viewport and cannot extend any scroll
   area. Keep them fixed, or animate them without moving them — not neither. */
.auth-wrapper::before {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(circle at 20% 30%, var(--primary-soft) 0%, transparent 50%), radial-gradient(circle at 80% 70%, var(--primary-soft) 0%, transparent 50%);
  z-index: 0;
  animation: pulseGlow 8s ease-in-out infinite;
}
.auth-wrapper::after {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(45deg, transparent 30%, var(--primary-soft) 50%, transparent 70%);
  z-index: 0;
  opacity: 0.6;
  animation: shimmer 6s linear infinite;
}

.bg-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  opacity: 1;
  filter: blur(0px);
  transition: opacity 0.3s ease;
  animation: fadeInAnimation 1.5s ease-out;
}
@media (max-width: 1024px) {
  .bg-animation {
    opacity: 0.9;
    filter: blur(0.2px);
  }
}
@media (max-width: 768px) {
  .bg-animation {
    opacity: 0.85;
    filter: blur(0.4px);
  }
}
@media (max-width: 480px) {
  .bg-animation {
    opacity: 0.8;
    filter: blur(0.6px);
  }
}

.image-canvas {
  filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.4));
  animation: canvasPulse 5s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .image-canvas {
    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.3));
  }
}
@media (max-width: 768px) {
  .image-canvas {
    filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.25));
  }
}

.drawing-cursor {
  filter: drop-shadow(0 0 8px rgba(16, 185, 129, 0.7));
  pointer-events: none;
  animation: cursorPulse 2s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .drawing-cursor {
    filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.6));
  }
}
@media (max-width: 768px) {
  .drawing-cursor {
    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.5));
  }
}

.drawing-boxes {
  filter: drop-shadow(0 0 7px rgba(16, 185, 129, 0.6));
  animation: boxGlow 3s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .drawing-boxes {
    filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));
  }
}

.data-points {
  filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.5));
  animation: pointPulse 2.5s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .data-points {
    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.4));
  }
}

.classification-icons {
  filter: drop-shadow(0 0 7px rgba(52, 211, 153, 0.6));
  animation: iconFloat 3s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .classification-icons {
    filter: drop-shadow(0 0 5px rgba(52, 211, 153, 0.5));
  }
}

.label-tags {
  filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.5));
  animation: tagFloat 4s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .label-tags {
    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.4));
  }
}

.network-lines {
  filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.4));
  animation: linePulse 3s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .network-lines {
    filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.3));
  }
}

.particles {
  filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));
  animation: particleFloat 4s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .particles {
    filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.4));
  }
}

.moving-image {
  filter: drop-shadow(0 0 8px rgba(16, 185, 129, 0.6));
  animation: imageFloat 5s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .moving-image {
    filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));
  }
}

.moving-class {
  filter: drop-shadow(0 0 10px rgba(52, 211, 153, 0.7));
  animation: classFloat 6s ease-in-out infinite;
}
@media (max-width: 1024px) {
  .moving-class {
    filter: drop-shadow(0 0 6px rgba(52, 211, 153, 0.6));
  }
}

@keyframes canvasPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.85;
    transform: scale(1.02);
  }
}
@keyframes fadeInAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.85;
  }
}
@keyframes cursorPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}
@keyframes boxGlow {
  0%, 100% {
    filter: drop-shadow(0 0 7px rgba(16, 185, 129, 0.6));
  }
  50% {
    filter: drop-shadow(0 0 12px rgba(16, 185, 129, 0.8));
  }
}
@keyframes pointPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.15);
  }
}
@keyframes iconFloat {
  0%, 100% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(-5px);
    opacity: 0.9;
  }
}
@keyframes tagFloat {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateY(-3px) scale(1.05);
    opacity: 0.95;
  }
}
@keyframes linePulse {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.7;
  }
}
@keyframes particleFloat {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}
@keyframes imageFloat {
  0%, 100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  50% {
    opacity: 0.95;
    transform: translateY(-5px) scale(1.02);
  }
}
@keyframes classFloat {
  0%, 100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  50% {
    opacity: 0.9;
    transform: translateY(-8px) scale(1.05);
  }
}
.auth-wrapper--simple {
  background:
    radial-gradient(1000px 640px at 80% -5%, var(--primary-soft) 0%, transparent 58%),
    radial-gradient(820px 560px at -5% 105%, var(--primary-soft) 0%, transparent 52%),
    var(--page-bg);
}
.auth-wrapper--simple::before, .auth-wrapper--simple::after {
  opacity: 0.5;
}

.auth-layout--simple {
  flex-direction: column;
  justify-content: center;
}
@media (min-width: 1025px) {
  .auth-layout--simple {
    flex-direction: row;
    justify-content: flex-end;
  }
}

.auth-hero {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  z-index: 5;
  min-height: 0;
}
@media (min-width: 1025px) {
  .auth-hero {
    flex: 1 1;
    min-width: 0;
    padding: 60px 48px 60px 80px;
    justify-content: center;
    align-items: center;
  }
}

.auth-hero__inner {
  text-align: center;
  max-width: 420px;
}
@media (min-width: 1025px) {
  .auth-hero__inner {
    text-align: left;
    max-width: min(560px, 100%);
  }
}

.auth-hero__headline {
  margin: 0 0 0.75rem 0;
  font-size: clamp(2.75rem, 7.5vw, 4.25rem);
  font-weight: 400;
  letter-spacing: -0.03em;
  line-height: 1.12;
  font-family: var(--font-sans);
  color: var(--foreground);
}
@media (min-width: 1025px) {
  .auth-hero__headline {
    /* Sized so the rotating word's 15ch still fits the hero column. At 5.5vw
       the word was ~600px wide inside a 480px column and spilled off-screen. */
    font-size: clamp(2.5rem, 3.2vw, 4rem);
    margin-bottom: 1rem;
  }
}

.auth-hero__tagline-wrap {
  margin: 0 0 1.75rem 0;
  padding: 1rem 1.25rem;
  background: var(--card);
  border: 1px solid var(--border);
  border-left: 4px solid var(--primary);
  border-radius: 0 var(--radius) var(--radius) 0;
  box-shadow: var(--shadow);
}
@media (min-width: 1025px) {
  .auth-hero__tagline-wrap {
    padding: 1.15rem 1.5rem;
    margin-bottom: 2rem;
    border-left-width: 5px;
  }
}

.auth-hero__tagline {
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 600;
  color: var(--card-foreground);
  letter-spacing: 0.02em;
  line-height: 1.5;
}
@media (min-width: 1025px) {
  .auth-hero__tagline {
    font-size: 1.125rem;
    font-weight: 600;
    letter-spacing: 0.025em;
  }
}

.auth-hero__features {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.auth-hero__feature {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: var(--muted-foreground);
  line-height: 1.45;
  letter-spacing: 0.01em;
}
@media (min-width: 1025px) {
  .auth-hero__feature {
    font-size: 0.9375rem;
    gap: 0.85rem;
  }
}

.auth-hero__feature-num {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-soft);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--accent-foreground);
}
@media (min-width: 1025px) {
  .auth-hero__feature-num {
    width: 1.6rem;
    height: 1.6rem;
    font-size: 0.8125rem;
  }
}

.auth-hero__feature-text {
  flex: 1 1;
  min-width: 0;
}
.auth-hero__feature-text strong {
  font-weight: 600;
  color: var(--foreground);
}

.auth-features {
  display: none;
}
@media (min-width: 1025px) {
  .auth-features {
    display: flex;
    flex: 1 1;
    align-items: center;
    justify-content: center;
    padding: 60px 80px;
    z-index: 5;
    min-width: 0;
  }
}

.auth-features__inner {
  max-width: 580px;
  animation: fadeInLeft 0.9s ease-out both;
}

.auth-features__title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--foreground);
  margin: 0 0 12px 0;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.auth-features__subtitle {
  font-size: 1rem;
  color: var(--muted-foreground);
  margin: 0 0 40px 0;
  line-height: 1.6;
}

.auth-features__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.auth-features__item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  margin-bottom: 12px;
  background: var(--card);
  backdrop-filter: blur(12px);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  color: var(--card-foreground);
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.4;
  transition: all var(--transition-slow);
  box-shadow: var(--shadow-sm);
  animation: featureSlideIn 0.6s ease-out both;
}
.auth-features__item:last-child {
  margin-bottom: 0;
}
.auth-features__item:hover {
  background: var(--card-hover);
  border-color: var(--primary);
  transform: translateX(6px);
  box-shadow: var(--shadow-glow);
}

.auth-features__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  background: linear-gradient(135deg, var(--primary) 0%, var(--brand-700) 100%);
  border-radius: var(--radius);
  color: var(--primary-foreground);
  font-size: 1rem;
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition-slow);
}

.auth-features__item:hover .auth-features__icon {
  transform: scale(1.08);
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes featureSlideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.auth-layout {
  position: relative;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: stretch !important;
  width: 100% !important;
  min-height: 100vh;
  min-height: 100dvh;
  z-index: 10;
  flex: 1 1;
  margin: 0 !important;
  padding: 0 !important;
}
@media (max-width: 1024px) {
  .auth-layout {
    justify-content: center !important;
  }
}

.auth-visual {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  z-index: 10;
  background: var(--page-bg-subtle);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden;
}
.auth-visual::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 30%, var(--primary-soft) 0%, transparent 50%), radial-gradient(circle at 80% 70%, var(--primary-soft) 0%, transparent 50%);
  z-index: -1;
}
@media (max-width: 1024px) {
  .auth-visual {
    display: none;
  }
}

.auth-content {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  padding: clamp(10px, 2.2vh, 40px) clamp(20px, 3vw, 48px) clamp(10px, 2.2vh, 40px) clamp(16px, 2vw, 24px) !important;
  z-index: 10;
  /* Fluid panel: a fixed 480px min-width left a 1025px laptop with a hero
     narrower than its own padding. The panel may now shrink, and the page
     scrolls instead of clipping when the card is taller than the viewport
     (a 1366x768 laptop used to lose the "Sign Up" footer with no way to it). */
  width: auto !important;
  flex: 0 1 clamp(400px, 32vw, 540px) !important;
  min-width: 0 !important;
  max-width: 540px !important;
  min-height: 100vh !important;
  min-height: 100dvh !important;
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
  background: var(--header);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  margin-left: auto !important;
  margin-right: 0 !important;
  flex-shrink: 1 !important;
  flex-grow: 0 !important;
  border-left: 1px solid var(--border);
}
@media (min-width: 1400px) {
  .auth-content {
    padding: clamp(32px, 5vh, 60px) 64px clamp(32px, 5vh, 60px) 48px !important;
    flex-basis: clamp(420px, 30vw, 560px) !important;
    max-width: 560px !important;
  }
}
.auth-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--primary-soft) 0%, transparent 50%), linear-gradient(225deg, var(--primary-soft) 0%, transparent 50%);
  z-index: -1;
  opacity: 0.6;
}
.auth-content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, var(--primary-soft) 2px, var(--primary-soft) 4px), repeating-linear-gradient(90deg, transparent, transparent 2px, var(--primary-soft) 2px, var(--primary-soft) 4px);
  z-index: -1;
  opacity: 0.25;
}
@media (max-width: 1024px) {
  .auth-content {
    width: 100%;
    min-width: auto;
    padding: 40px 24px !important;
    background: transparent;
    justify-content: center;
    align-items: center;
    height: auto !important;
    min-height: 100vh !important;
    max-height: none !important;
    overflow: visible !important;
    border-left: none;
  }
  .auth-content::before, .auth-content::after {
    display: none;
  }
}
@media (max-width: 768px) {
  .auth-content {
    padding: 20px 15px !important;
    height: auto !important;
    max-height: none !important;
  }
}
@media (max-width: 576px) {
  .auth-content {
    padding: 15px 10px !important;
    height: auto !important;
    max-height: none !important;
  }
}

.logo-container {
  margin-bottom: 0;
  animation: fadeInDown 0.8s ease-out;
  position: relative;
  text-align: center;
}
.logo-container::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, var(--primary-soft) 0%, transparent 70%);
  border-radius: var(--radius-full);
  z-index: -1;
  animation: pulseRing 3s ease-out infinite;
}
.logo-container .logo-img {
  max-width: 220px;
  height: auto;
  margin-bottom: 16px;
  filter: drop-shadow(0 4px 20px rgba(16, 185, 129, 0.5)) drop-shadow(0 0 30px rgba(16, 185, 129, 0.3));
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
}
.logo-container .logo-img:hover {
  transform: scale(1.08) translateY(-2px);
  filter: drop-shadow(0 6px 24px rgba(16, 185, 129, 0.6)) drop-shadow(0 0 40px rgba(16, 185, 129, 0.4));
}
.logo-container .logo-title {
  display: none;
}
.logo-container .logo-subtitle {
  font-size: 16px;
  color: var(--muted-foreground);
  margin: 0;
  font-weight: 500;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes pulseGlow {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}
@keyframes pulseRing {
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0;
  }
}
@keyframes cardShimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}
@keyframes titleUnderline {
  0%, 100% {
    width: 80px;
    opacity: 1;
  }
  50% {
    width: 120px;
    opacity: 0.8;
  }
}
@keyframes accentLine {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 0%;
  }
  100% {
    background-position: 0% 0%;
  }
}
@keyframes buttonGradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@media (max-width: 1024px) {
  /* Below the desktop split (>=1025px), collapse to a single, full-width,
     centered form column. Overrides need !important because the desktop base
     rules for .auth-content are themselves !important (min-width:480px etc). */
  .auth-layout,
  .auth-layout--simple {
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
  }
  /* Marketing hero is desktop-only (matches the original form-only mobile). */
  .auth-hero {
    display: none !important;
  }
  .auth-content {
    position: relative !important;
    min-width: 0 !important;
    width: 100% !important;
    max-width: 480px !important;
    height: auto !important;
    max-height: none !important;
    min-height: 100vh !important;
    min-height: 100dvh !important;
    margin: 0 auto !important;
    padding: 40px 20px !important;
    padding-top: max(40px, env(safe-area-inset-top)) !important;
    padding-bottom: max(40px, env(safe-area-inset-bottom)) !important;
    overflow: visible !important;
    flex: 0 1 auto !important;
    flex-shrink: 1 !important;
    justify-content: center !important;
    align-items: center !important;
    background: transparent !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
  }
  .auth-content::before, .auth-content::after {
    display: none;
  }
  .login-box {
    max-width: 100% !important;
    width: 100% !important;
  }
  .login-card {
    max-width: 100% !important;
    width: 100% !important;
    margin: 0 auto;
  }
  .logo-container {
    margin-bottom: 40px;
    display: block;
    text-align: center;
  }
  .logo-container .logo-img {
    max-width: 180px;
  }
  .logo-container .logo-subtitle {
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .auth-wrapper {
    padding: 20px;
  }
  .auth-content {
    padding: 30px 20px;
    min-height: calc(100vh - 40px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .login-box {
    width: 100%;
    max-width: 100%;
  }
  .login-card {
    padding: 40px 32px;
    max-width: 100%;
    border-radius: 28px;
  }
  .logo-container {
    margin-bottom: 32px;
  }
  .logo-container .logo-img {
    max-width: 160px;
  }
  .logo-container .logo-subtitle {
    font-size: 13px;
  }
  .login-header {
    margin-bottom: 32px;
  }
  .login-header .login-title {
    font-size: 26px;
  }
  .login-header .login-description {
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .auth-wrapper {
    padding: 15px;
  }
  .auth-content {
    padding: 20px 15px;
    min-height: calc(100vh - 30px);
  }
  .login-card {
    padding: 32px 24px;
    border-radius: 24px;
  }
  .logo-container {
    margin-bottom: 28px;
  }
  .logo-container .logo-img {
    max-width: 140px;
  }
  .logo-container .logo-subtitle {
    font-size: 12px;
  }
  .login-header {
    margin-bottom: 28px;
  }
  .login-header .login-title {
    font-size: 24px;
  }
  .login-header .login-description {
    font-size: 13px;
  }
  .login-form .form-group {
    margin-bottom: 20px;
  }
}
/* Short desktop viewports — a 1366x768 laptop leaves ~640px of usable height,
   less than the hero's 120px of vertical padding + headline + tagline + four
   feature rows. Compress rather than push the page into a scroll. */
@media (min-width: 1025px) and (max-height: 820px) {
  .auth-hero {
    padding: 32px 40px 32px 56px;
  }
  .auth-hero__headline {
    font-size: clamp(2.25rem, 2.8vw, 3.25rem);
    margin-bottom: 0.6rem;
  }
  .auth-hero__tagline-wrap {
    padding: 0.85rem 1.15rem;
    margin-bottom: 1.25rem;
  }
  .auth-hero__features {
    gap: 0.55rem;
  }
}
@media (min-width: 1025px) and (max-height: 680px) {
  .auth-hero {
    padding: 24px 32px 24px 40px;
  }
  .auth-hero__tagline-wrap {
    margin-bottom: 1rem;
  }
  .auth-hero__feature {
    font-size: 0.8125rem;
  }
  .auth-hero__features {
    gap: 0.4rem;
  }
}

.overlay {
  display: none;
}

/* ===========================================================================
   Sign-in second step — the link and bootstrap rows.

   HAND-WRITTEN, AND NOT PRESENT IN login.scss. The rest of this file is
   compiled from that sheet; these rules are not, because the login screen's
   card markup and its stylesheet are owned by different changes and the SCSS
   was not available to this one. Anybody who recompiles login.scss must carry
   this block across (or move it into MainSection.scss, where the rest of the
   card's chrome lives) — otherwise the second step loses its spacing and the
   read-only fields stop looking read-only.

   Tokens only. Both themes come out of theme.css, so nothing here needs a
   \`html.dark\` twin.
   =========================================================================== */

/* A field the cascade is still holding: it is the exact pair that was already
   proved, so it must not drift while the second password is typed. Read-only
   rather than disabled — the address is the thing the second password belongs
   to, so it has to stay readable, selectable and in the tab order. The sunken
   ground is what says so; without it an uneditable field reads as broken.
   Specificity beats MainSection.scss's four-class \`.form-input\` rule. */
.login-form .form-group .input-wrapper .form-input[readonly] {
  background: var(--muted);
  color: var(--muted-foreground);
  border-color: var(--border);
  cursor: default;
}
.login-form .form-group .input-wrapper .form-input[readonly]:hover:not(:focus) {
  background: var(--muted);
  border-color: var(--border);
}

.login-link-step {
  margin-top: 4px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  animation: fadeInUp 0.35s ease-out both;
}

/* The server's own sentence. It is an explanation, not an alarm: the person did
   nothing wrong, and the remedy is the field directly under it. */
.login-link-step__note {
  margin: 0 0 16px 0;
  font-size: 0.8125rem;
  line-height: 1.55;
  color: var(--muted-foreground);
}

/* A local validation failure — the only message on this card we write
   ourselves. \`*-soft\` ground always takes its solid partner as text colour. */
.login-link-step__error {
  margin: 0 0 16px 0;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  background: var(--destructive-soft);
  color: var(--destructive);
  font-size: 0.8125rem;
  line-height: 1.45;
}

.login-link-step__actions {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

/* Which OTHER accounts these two fields accept. A sentence, never a picker:
   there is nothing to choose, and a choice offered before the password is typed
   is a choice somebody gets wrong and reads back as a wrong password. */
.login-alt {
  margin: 16px 0 0 0;
  font-size: 0.8125rem;
  line-height: 1.55;
  color: var(--muted-foreground);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/login/styles/login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kDAAkD;EAClD,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,sCAAsC;EACtC;;;;;;;mEAOiE;EACjE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB;;;kBAGgB;AAClB;AACA;;;;;8EAK8E;AAC9E;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,oKAAoK;EACpK,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,6FAA6F;EAC7F,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE,oDAAoD;EACpD,8CAA8C;AAChD;AACA;EACE;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE,oDAAoD;EACpD,oBAAoB;EACpB,8CAA8C;AAChD;AACA;EACE;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,oDAAoD;EACpD,0CAA0C;AAC5C;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,oDAAoD;EACpD,+CAA+C;AACjD;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;AAC9C;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;AAC7C;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;AAC9C;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,oDAAoD;EACpD,gDAAgD;AAClD;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,oDAAoD;EACpD,6CAA6C;AAC/C;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;AAC/C;AACA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;AACA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,qDAAqD;EACvD;AACF;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;AACA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,YAAY;EACd;AACF;AACA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,uCAAuC;IACvC,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;AACA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,uCAAuC;EACzC;AACF;AACA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,YAAY;IACZ,uCAAuC;EACzC;AACF;AACA;EACE;;;kBAGgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,aAAa;AACf;AACA;EACE;IACE,SAAO;IACP,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;AACF;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE;IACE;+EAC2E;IAC3E,qCAAqC;IACrC,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;EAC/B,qCAAqC;EACrC,8CAA8C;EAC9C,yBAAyB;AAC3B;AACA;EACE;IACE,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE;IACE,oBAAoB;IACpB,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE;IACE,aAAa;IACb,cAAc;IACd,oBAAoB;EACtB;AACF;;AAEA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,4BAA4B;EAC5B,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,6EAA6E;EAC7E,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oCAAoC;EACpC,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAO;EACP,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oKAAoK;EACpK,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,mHAAmH;EACnH,WAAW;EACX;;;+EAG6E;EAC7E,sBAAsB;EACtB,8CAA8C;EAC9C,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE;IACE,2EAA2E;IAC3E,gDAAgD;IAChD,2BAA2B;EAC7B;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8IAA8I;EAC9I,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mPAAmP;EACnP,WAAW;EACX,aAAa;AACf;AACA;EACE;IACE,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,4EAA4E;EAC5E,iCAAiC;EACjC,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qGAAqG;EACrG,iDAAiD;EACjD,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,uCAAuC;EACvC,qGAAqG;AACvG;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,4DAA4D;EAC9D;EACA;IACE,0DAA0D;EAC5D;AACF;AACA;EACE;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;AACA;EACE;IACE,4DAA4D;EAC9D;EACA;IACE,0DAA0D;EAC5D;AACF;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;;+EAE6E;EAC7E;;IAEE,iCAAiC;IACjC,kCAAkC;IAClC,8BAA8B;EAChC;EACA,4EAA4E;EAC5E;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,2DAA2D;IAC3D,iEAAiE;IACjE,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,kCAAkC;IAClC,8BAA8B;IAC9B,kCAAkC;IAClC,gCAAgC;IAChC,wCAAwC;EAC1C;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;;oEAEoE;AACpE;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yCAAyC;IACzC,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;gFAagF;;AAEhF;;;;;wEAKwE;AACxE;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;kEACkE;AAClE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;8EAC8E;AAC9E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;wEAEwE;AACxE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB","sourcesContent":[".auth-logo-top {\n  position: absolute;\n  top: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.auth-logo-top .top-logo-img {\n  height: 50px;\n  width: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));\n  transition: transform 0.3s ease;\n}\n.auth-logo-top .top-logo-img:hover {\n  transform: scale(1.05);\n}\n@media (max-width: 1024px) {\n  .auth-logo-top {\n    top: 20px;\n  }\n  .auth-logo-top .top-logo-img {\n    height: 40px;\n  }\n}\n@media (max-width: 576px) {\n  .auth-logo-top {\n    top: 15px;\n  }\n  .auth-logo-top .top-logo-img {\n    height: 35px;\n  }\n}\n\n.auth-wrapper {\n  position: relative;\n  display: flex !important;\n  align-items: stretch !important;\n  justify-content: flex-start !important;\n  /* There is ONE scroller on this page and it is the page itself.\n     `overflow-x: hidden` with `overflow-y: visible` is not a valid pair — CSS\n     computes the visible axis to `auto` — so this quietly made the wrapper its\n     own scroll container. The decorative sweep below then swung THAT box's\n     scroll height between 687px and 1750px every 6s (measured), which is the\n     scrollbar that crept down, reset, and crept again. `html, body` already\n     carry `overflow-x: hidden` (responsive.css §1), so the wrapper needs no\n     overflow of its own; it must only never clip the form again. */\n  overflow: visible;\n  min-width: 100%;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background:\n    radial-gradient(1100px 700px at 85% -10%, var(--primary-soft) 0%, transparent 60%),\n    radial-gradient(900px 650px at -10% 110%, var(--primary-soft) 0%, transparent 55%),\n    var(--page-bg);\n}\n/* Both ambient layers are FIXED, not absolute. They are full-viewport\n   decoration, and `shimmer` below translates its layer a whole viewport in each\n   direction (plus a 45deg rotation, which grows its box by ~1.41x). As absolute\n   children that travel was added to the ancestor's scrollable height on every\n   frame; a fixed box is anchored to the viewport and cannot extend any scroll\n   area. Keep them fixed, or animate them without moving them — not neither. */\n.auth-wrapper::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  background: radial-gradient(circle at 20% 30%, var(--primary-soft) 0%, transparent 50%), radial-gradient(circle at 80% 70%, var(--primary-soft) 0%, transparent 50%);\n  z-index: 0;\n  animation: pulseGlow 8s ease-in-out infinite;\n}\n.auth-wrapper::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  background: linear-gradient(45deg, transparent 30%, var(--primary-soft) 50%, transparent 70%);\n  z-index: 0;\n  opacity: 0.6;\n  animation: shimmer 6s linear infinite;\n}\n\n.bg-animation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  opacity: 1;\n  filter: blur(0px);\n  transition: opacity 0.3s ease;\n  animation: fadeInAnimation 1.5s ease-out;\n}\n@media (max-width: 1024px) {\n  .bg-animation {\n    opacity: 0.9;\n    filter: blur(0.2px);\n  }\n}\n@media (max-width: 768px) {\n  .bg-animation {\n    opacity: 0.85;\n    filter: blur(0.4px);\n  }\n}\n@media (max-width: 480px) {\n  .bg-animation {\n    opacity: 0.8;\n    filter: blur(0.6px);\n  }\n}\n\n.image-canvas {\n  filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.4));\n  animation: canvasPulse 5s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .image-canvas {\n    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.3));\n  }\n}\n@media (max-width: 768px) {\n  .image-canvas {\n    filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.25));\n  }\n}\n\n.drawing-cursor {\n  filter: drop-shadow(0 0 8px rgba(16, 185, 129, 0.7));\n  pointer-events: none;\n  animation: cursorPulse 2s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .drawing-cursor {\n    filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.6));\n  }\n}\n@media (max-width: 768px) {\n  .drawing-cursor {\n    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.5));\n  }\n}\n\n.drawing-boxes {\n  filter: drop-shadow(0 0 7px rgba(16, 185, 129, 0.6));\n  animation: boxGlow 3s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .drawing-boxes {\n    filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));\n  }\n}\n\n.data-points {\n  filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.5));\n  animation: pointPulse 2.5s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .data-points {\n    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.4));\n  }\n}\n\n.classification-icons {\n  filter: drop-shadow(0 0 7px rgba(52, 211, 153, 0.6));\n  animation: iconFloat 3s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .classification-icons {\n    filter: drop-shadow(0 0 5px rgba(52, 211, 153, 0.5));\n  }\n}\n\n.label-tags {\n  filter: drop-shadow(0 0 6px rgba(16, 185, 129, 0.5));\n  animation: tagFloat 4s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .label-tags {\n    filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.4));\n  }\n}\n\n.network-lines {\n  filter: drop-shadow(0 0 4px rgba(16, 185, 129, 0.4));\n  animation: linePulse 3s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .network-lines {\n    filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.3));\n  }\n}\n\n.particles {\n  filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));\n  animation: particleFloat 4s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .particles {\n    filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.4));\n  }\n}\n\n.moving-image {\n  filter: drop-shadow(0 0 8px rgba(16, 185, 129, 0.6));\n  animation: imageFloat 5s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .moving-image {\n    filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.5));\n  }\n}\n\n.moving-class {\n  filter: drop-shadow(0 0 10px rgba(52, 211, 153, 0.7));\n  animation: classFloat 6s ease-in-out infinite;\n}\n@media (max-width: 1024px) {\n  .moving-class {\n    filter: drop-shadow(0 0 6px rgba(52, 211, 153, 0.6));\n  }\n}\n\n@keyframes canvasPulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.85;\n    transform: scale(1.02);\n  }\n}\n@keyframes fadeInAnimation {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 0.85;\n  }\n}\n@keyframes cursorPulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.1);\n  }\n}\n@keyframes boxGlow {\n  0%, 100% {\n    filter: drop-shadow(0 0 7px rgba(16, 185, 129, 0.6));\n  }\n  50% {\n    filter: drop-shadow(0 0 12px rgba(16, 185, 129, 0.8));\n  }\n}\n@keyframes pointPulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.15);\n  }\n}\n@keyframes iconFloat {\n  0%, 100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  50% {\n    transform: translateY(-5px);\n    opacity: 0.9;\n  }\n}\n@keyframes tagFloat {\n  0%, 100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: translateY(-3px) scale(1.05);\n    opacity: 0.95;\n  }\n}\n@keyframes linePulse {\n  0%, 100% {\n    opacity: 0.4;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n@keyframes particleFloat {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.1);\n  }\n}\n@keyframes imageFloat {\n  0%, 100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n  50% {\n    opacity: 0.95;\n    transform: translateY(-5px) scale(1.02);\n  }\n}\n@keyframes classFloat {\n  0%, 100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n  50% {\n    opacity: 0.9;\n    transform: translateY(-8px) scale(1.05);\n  }\n}\n.auth-wrapper--simple {\n  background:\n    radial-gradient(1000px 640px at 80% -5%, var(--primary-soft) 0%, transparent 58%),\n    radial-gradient(820px 560px at -5% 105%, var(--primary-soft) 0%, transparent 52%),\n    var(--page-bg);\n}\n.auth-wrapper--simple::before, .auth-wrapper--simple::after {\n  opacity: 0.5;\n}\n\n.auth-layout--simple {\n  flex-direction: column;\n  justify-content: center;\n}\n@media (min-width: 1025px) {\n  .auth-layout--simple {\n    flex-direction: row;\n    justify-content: flex-end;\n  }\n}\n\n.auth-hero {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1.5rem;\n  z-index: 5;\n  min-height: 0;\n}\n@media (min-width: 1025px) {\n  .auth-hero {\n    flex: 1;\n    min-width: 0;\n    padding: 60px 48px 60px 80px;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.auth-hero__inner {\n  text-align: center;\n  max-width: 420px;\n}\n@media (min-width: 1025px) {\n  .auth-hero__inner {\n    text-align: left;\n    max-width: min(560px, 100%);\n  }\n}\n\n.auth-hero__headline {\n  margin: 0 0 0.75rem 0;\n  font-size: clamp(2.75rem, 7.5vw, 4.25rem);\n  font-weight: 400;\n  letter-spacing: -0.03em;\n  line-height: 1.12;\n  font-family: var(--font-sans);\n  color: var(--foreground);\n}\n@media (min-width: 1025px) {\n  .auth-hero__headline {\n    /* Sized so the rotating word's 15ch still fits the hero column. At 5.5vw\n       the word was ~600px wide inside a 480px column and spilled off-screen. */\n    font-size: clamp(2.5rem, 3.2vw, 4rem);\n    margin-bottom: 1rem;\n  }\n}\n\n.auth-hero__tagline-wrap {\n  margin: 0 0 1.75rem 0;\n  padding: 1rem 1.25rem;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--primary);\n  border-radius: 0 var(--radius) var(--radius) 0;\n  box-shadow: var(--shadow);\n}\n@media (min-width: 1025px) {\n  .auth-hero__tagline-wrap {\n    padding: 1.15rem 1.5rem;\n    margin-bottom: 2rem;\n    border-left-width: 5px;\n  }\n}\n\n.auth-hero__tagline {\n  margin: 0;\n  font-size: 1.0625rem;\n  font-weight: 600;\n  color: var(--card-foreground);\n  letter-spacing: 0.02em;\n  line-height: 1.5;\n}\n@media (min-width: 1025px) {\n  .auth-hero__tagline {\n    font-size: 1.125rem;\n    font-weight: 600;\n    letter-spacing: 0.025em;\n  }\n}\n\n.auth-hero__features {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.auth-hero__feature {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  font-size: 0.875rem;\n  color: var(--muted-foreground);\n  line-height: 1.45;\n  letter-spacing: 0.01em;\n}\n@media (min-width: 1025px) {\n  .auth-hero__feature {\n    font-size: 0.9375rem;\n    gap: 0.85rem;\n  }\n}\n\n.auth-hero__feature-num {\n  flex-shrink: 0;\n  width: 1.5rem;\n  height: 1.5rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--primary-soft);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--accent-foreground);\n}\n@media (min-width: 1025px) {\n  .auth-hero__feature-num {\n    width: 1.6rem;\n    height: 1.6rem;\n    font-size: 0.8125rem;\n  }\n}\n\n.auth-hero__feature-text {\n  flex: 1;\n  min-width: 0;\n}\n.auth-hero__feature-text strong {\n  font-weight: 600;\n  color: var(--foreground);\n}\n\n.auth-features {\n  display: none;\n}\n@media (min-width: 1025px) {\n  .auth-features {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 80px;\n    z-index: 5;\n    min-width: 0;\n  }\n}\n\n.auth-features__inner {\n  max-width: 580px;\n  animation: fadeInLeft 0.9s ease-out both;\n}\n\n.auth-features__title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--foreground);\n  margin: 0 0 12px 0;\n  letter-spacing: -0.5px;\n  line-height: 1.2;\n}\n\n.auth-features__subtitle {\n  font-size: 1rem;\n  color: var(--muted-foreground);\n  margin: 0 0 40px 0;\n  line-height: 1.6;\n}\n\n.auth-features__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.auth-features__item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  margin-bottom: 12px;\n  background: var(--card);\n  backdrop-filter: blur(12px);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  color: var(--card-foreground);\n  font-size: 0.9375rem;\n  font-weight: 500;\n  line-height: 1.4;\n  transition: all var(--transition-slow);\n  box-shadow: var(--shadow-sm);\n  animation: featureSlideIn 0.6s ease-out both;\n}\n.auth-features__item:last-child {\n  margin-bottom: 0;\n}\n.auth-features__item:hover {\n  background: var(--card-hover);\n  border-color: var(--primary);\n  transform: translateX(6px);\n  box-shadow: var(--shadow-glow);\n}\n\n.auth-features__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, var(--primary) 0%, var(--brand-700) 100%);\n  border-radius: var(--radius);\n  color: var(--primary-foreground);\n  font-size: 1rem;\n  box-shadow: var(--shadow-sm);\n  transition: transform var(--transition-slow);\n}\n\n.auth-features__item:hover .auth-features__icon {\n  transform: scale(1.08);\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n@keyframes featureSlideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n.auth-layout {\n  position: relative;\n  display: flex !important;\n  justify-content: flex-end !important;\n  align-items: stretch !important;\n  width: 100% !important;\n  min-height: 100vh;\n  min-height: 100dvh;\n  z-index: 10;\n  flex: 1;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n@media (max-width: 1024px) {\n  .auth-layout {\n    justify-content: center !important;\n  }\n}\n\n.auth-visual {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 40px;\n  z-index: 10;\n  background: var(--page-bg-subtle);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  overflow: hidden;\n}\n.auth-visual::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 20% 30%, var(--primary-soft) 0%, transparent 50%), radial-gradient(circle at 80% 70%, var(--primary-soft) 0%, transparent 50%);\n  z-index: -1;\n}\n@media (max-width: 1024px) {\n  .auth-visual {\n    display: none;\n  }\n}\n\n.auth-content {\n  position: relative !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-end !important;\n  padding: clamp(10px, 2.2vh, 40px) clamp(20px, 3vw, 48px) clamp(10px, 2.2vh, 40px) clamp(16px, 2vw, 24px) !important;\n  z-index: 10;\n  /* Fluid panel: a fixed 480px min-width left a 1025px laptop with a hero\n     narrower than its own padding. The panel may now shrink, and the page\n     scrolls instead of clipping when the card is taller than the viewport\n     (a 1366x768 laptop used to lose the \"Sign Up\" footer with no way to it). */\n  width: auto !important;\n  flex: 0 1 clamp(400px, 32vw, 540px) !important;\n  min-width: 0 !important;\n  max-width: 540px !important;\n  min-height: 100vh !important;\n  min-height: 100dvh !important;\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n  background: var(--header);\n  backdrop-filter: blur(25px);\n  -webkit-backdrop-filter: blur(25px);\n  margin-left: auto !important;\n  margin-right: 0 !important;\n  flex-shrink: 1 !important;\n  flex-grow: 0 !important;\n  border-left: 1px solid var(--border);\n}\n@media (min-width: 1400px) {\n  .auth-content {\n    padding: clamp(32px, 5vh, 60px) 64px clamp(32px, 5vh, 60px) 48px !important;\n    flex-basis: clamp(420px, 30vw, 560px) !important;\n    max-width: 560px !important;\n  }\n}\n.auth-content::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--primary-soft) 0%, transparent 50%), linear-gradient(225deg, var(--primary-soft) 0%, transparent 50%);\n  z-index: -1;\n  opacity: 0.6;\n}\n.auth-content::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, var(--primary-soft) 2px, var(--primary-soft) 4px), repeating-linear-gradient(90deg, transparent, transparent 2px, var(--primary-soft) 2px, var(--primary-soft) 4px);\n  z-index: -1;\n  opacity: 0.25;\n}\n@media (max-width: 1024px) {\n  .auth-content {\n    width: 100%;\n    min-width: auto;\n    padding: 40px 24px !important;\n    background: transparent;\n    justify-content: center;\n    align-items: center;\n    height: auto !important;\n    min-height: 100vh !important;\n    max-height: none !important;\n    overflow: visible !important;\n    border-left: none;\n  }\n  .auth-content::before, .auth-content::after {\n    display: none;\n  }\n}\n@media (max-width: 768px) {\n  .auth-content {\n    padding: 20px 15px !important;\n    height: auto !important;\n    max-height: none !important;\n  }\n}\n@media (max-width: 576px) {\n  .auth-content {\n    padding: 15px 10px !important;\n    height: auto !important;\n    max-height: none !important;\n  }\n}\n\n.logo-container {\n  margin-bottom: 0;\n  animation: fadeInDown 0.8s ease-out;\n  position: relative;\n  text-align: center;\n}\n.logo-container::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, var(--primary-soft) 0%, transparent 70%);\n  border-radius: var(--radius-full);\n  z-index: -1;\n  animation: pulseRing 3s ease-out infinite;\n}\n.logo-container .logo-img {\n  max-width: 220px;\n  height: auto;\n  margin-bottom: 16px;\n  filter: drop-shadow(0 4px 20px rgba(16, 185, 129, 0.5)) drop-shadow(0 0 30px rgba(16, 185, 129, 0.3));\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  z-index: 1;\n}\n.logo-container .logo-img:hover {\n  transform: scale(1.08) translateY(-2px);\n  filter: drop-shadow(0 6px 24px rgba(16, 185, 129, 0.6)) drop-shadow(0 0 40px rgba(16, 185, 129, 0.4));\n}\n.logo-container .logo-title {\n  display: none;\n}\n.logo-container .logo-subtitle {\n  font-size: 16px;\n  color: var(--muted-foreground);\n  margin: 0;\n  font-weight: 500;\n  letter-spacing: 1px;\n  position: relative;\n  z-index: 1;\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes gradientShift {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n@keyframes pulseGlow {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n}\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%) translateY(-100%) rotate(45deg);\n  }\n  100% {\n    transform: translateX(100%) translateY(100%) rotate(45deg);\n  }\n}\n@keyframes pulseRing {\n  0% {\n    transform: translate(-50%, -50%) scale(0.8);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(1.2);\n    opacity: 0;\n  }\n}\n@keyframes cardShimmer {\n  0% {\n    transform: translateX(-100%) translateY(-100%) rotate(45deg);\n  }\n  100% {\n    transform: translateX(100%) translateY(100%) rotate(45deg);\n  }\n}\n@keyframes titleUnderline {\n  0%, 100% {\n    width: 80px;\n    opacity: 1;\n  }\n  50% {\n    width: 120px;\n    opacity: 0.8;\n  }\n}\n@keyframes accentLine {\n  0% {\n    background-position: 0% 0%;\n  }\n  50% {\n    background-position: 100% 0%;\n  }\n  100% {\n    background-position: 0% 0%;\n  }\n}\n@keyframes buttonGradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n@media (max-width: 1024px) {\n  /* Below the desktop split (>=1025px), collapse to a single, full-width,\n     centered form column. Overrides need !important because the desktop base\n     rules for .auth-content are themselves !important (min-width:480px etc). */\n  .auth-layout,\n  .auth-layout--simple {\n    flex-direction: column !important;\n    justify-content: center !important;\n    align-items: center !important;\n  }\n  /* Marketing hero is desktop-only (matches the original form-only mobile). */\n  .auth-hero {\n    display: none !important;\n  }\n  .auth-content {\n    position: relative !important;\n    min-width: 0 !important;\n    width: 100% !important;\n    max-width: 480px !important;\n    height: auto !important;\n    max-height: none !important;\n    min-height: 100vh !important;\n    min-height: 100dvh !important;\n    margin: 0 auto !important;\n    padding: 40px 20px !important;\n    padding-top: max(40px, env(safe-area-inset-top)) !important;\n    padding-bottom: max(40px, env(safe-area-inset-bottom)) !important;\n    overflow: visible !important;\n    flex: 0 1 auto !important;\n    flex-shrink: 1 !important;\n    justify-content: center !important;\n    align-items: center !important;\n    background: transparent !important;\n    backdrop-filter: none !important;\n    -webkit-backdrop-filter: none !important;\n  }\n  .auth-content::before, .auth-content::after {\n    display: none;\n  }\n  .login-box {\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n  .login-card {\n    max-width: 100% !important;\n    width: 100% !important;\n    margin: 0 auto;\n  }\n  .logo-container {\n    margin-bottom: 40px;\n    display: block;\n    text-align: center;\n  }\n  .logo-container .logo-img {\n    max-width: 180px;\n  }\n  .logo-container .logo-subtitle {\n    font-size: 14px;\n  }\n}\n@media (max-width: 768px) {\n  .auth-wrapper {\n    padding: 20px;\n  }\n  .auth-content {\n    padding: 30px 20px;\n    min-height: calc(100vh - 40px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .login-box {\n    width: 100%;\n    max-width: 100%;\n  }\n  .login-card {\n    padding: 40px 32px;\n    max-width: 100%;\n    border-radius: 28px;\n  }\n  .logo-container {\n    margin-bottom: 32px;\n  }\n  .logo-container .logo-img {\n    max-width: 160px;\n  }\n  .logo-container .logo-subtitle {\n    font-size: 13px;\n  }\n  .login-header {\n    margin-bottom: 32px;\n  }\n  .login-header .login-title {\n    font-size: 26px;\n  }\n  .login-header .login-description {\n    font-size: 14px;\n  }\n}\n@media (max-width: 480px) {\n  .auth-wrapper {\n    padding: 15px;\n  }\n  .auth-content {\n    padding: 20px 15px;\n    min-height: calc(100vh - 30px);\n  }\n  .login-card {\n    padding: 32px 24px;\n    border-radius: 24px;\n  }\n  .logo-container {\n    margin-bottom: 28px;\n  }\n  .logo-container .logo-img {\n    max-width: 140px;\n  }\n  .logo-container .logo-subtitle {\n    font-size: 12px;\n  }\n  .login-header {\n    margin-bottom: 28px;\n  }\n  .login-header .login-title {\n    font-size: 24px;\n  }\n  .login-header .login-description {\n    font-size: 13px;\n  }\n  .login-form .form-group {\n    margin-bottom: 20px;\n  }\n}\n/* Short desktop viewports — a 1366x768 laptop leaves ~640px of usable height,\n   less than the hero's 120px of vertical padding + headline + tagline + four\n   feature rows. Compress rather than push the page into a scroll. */\n@media (min-width: 1025px) and (max-height: 820px) {\n  .auth-hero {\n    padding: 32px 40px 32px 56px;\n  }\n  .auth-hero__headline {\n    font-size: clamp(2.25rem, 2.8vw, 3.25rem);\n    margin-bottom: 0.6rem;\n  }\n  .auth-hero__tagline-wrap {\n    padding: 0.85rem 1.15rem;\n    margin-bottom: 1.25rem;\n  }\n  .auth-hero__features {\n    gap: 0.55rem;\n  }\n}\n@media (min-width: 1025px) and (max-height: 680px) {\n  .auth-hero {\n    padding: 24px 32px 24px 40px;\n  }\n  .auth-hero__tagline-wrap {\n    margin-bottom: 1rem;\n  }\n  .auth-hero__feature {\n    font-size: 0.8125rem;\n  }\n  .auth-hero__features {\n    gap: 0.4rem;\n  }\n}\n\n.overlay {\n  display: none;\n}\n\n/* ===========================================================================\n   Sign-in second step — the link and bootstrap rows.\n\n   HAND-WRITTEN, AND NOT PRESENT IN login.scss. The rest of this file is\n   compiled from that sheet; these rules are not, because the login screen's\n   card markup and its stylesheet are owned by different changes and the SCSS\n   was not available to this one. Anybody who recompiles login.scss must carry\n   this block across (or move it into MainSection.scss, where the rest of the\n   card's chrome lives) — otherwise the second step loses its spacing and the\n   read-only fields stop looking read-only.\n\n   Tokens only. Both themes come out of theme.css, so nothing here needs a\n   `html.dark` twin.\n   =========================================================================== */\n\n/* A field the cascade is still holding: it is the exact pair that was already\n   proved, so it must not drift while the second password is typed. Read-only\n   rather than disabled — the address is the thing the second password belongs\n   to, so it has to stay readable, selectable and in the tab order. The sunken\n   ground is what says so; without it an uneditable field reads as broken.\n   Specificity beats MainSection.scss's four-class `.form-input` rule. */\n.login-form .form-group .input-wrapper .form-input[readonly] {\n  background: var(--muted);\n  color: var(--muted-foreground);\n  border-color: var(--border);\n  cursor: default;\n}\n.login-form .form-group .input-wrapper .form-input[readonly]:hover:not(:focus) {\n  background: var(--muted);\n  border-color: var(--border);\n}\n\n.login-link-step {\n  margin-top: 4px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n  animation: fadeInUp 0.35s ease-out both;\n}\n\n/* The server's own sentence. It is an explanation, not an alarm: the person did\n   nothing wrong, and the remedy is the field directly under it. */\n.login-link-step__note {\n  margin: 0 0 16px 0;\n  font-size: 0.8125rem;\n  line-height: 1.55;\n  color: var(--muted-foreground);\n}\n\n/* A local validation failure — the only message on this card we write\n   ourselves. `*-soft` ground always takes its solid partner as text colour. */\n.login-link-step__error {\n  margin: 0 0 16px 0;\n  padding: 10px 12px;\n  border-radius: var(--radius-sm);\n  background: var(--destructive-soft);\n  color: var(--destructive);\n  font-size: 0.8125rem;\n  line-height: 1.45;\n}\n\n.login-link-step__actions {\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\n/* Which OTHER accounts these two fields accept. A sentence, never a picker:\n   there is nothing to choose, and a choice offered before the password is typed\n   is a choice somebody gets wrong and reads back as a wrong password. */\n.login-alt {\n  margin: 16px 0 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.55;\n  color: var(--muted-foreground);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
